import React from 'react';
import PropTypes from 'prop-types';

import { branch } from 'baobab-react/higher-order';

import Block from '@components/common/block';
import Input from '@components/common/input';

import BLOCKS from '../../../store/blocks';

import styles from './index.module.css';

function CoordsBlock(props) {
  return (
    <Block className={styles.block} header='Location'>
      <div className={styles.content}>
        <label className={styles.label}>
          X:{' '}
          <Input
            className={styles.input}
            disabled={true}
            value={props.pos.x >= 0 ? props.pos.x : ''}
          />
        </label>
        <label className={styles.label}>
          Y:{' '}
          <Input
            className={styles.input}
            disabled={true}
            value={props.pos.y >= 0 ? props.pos.y : ''}
          />
        </label>
      </div>
    </Block>
  );
}

CoordsBlock.propTypes = {
  pos: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
};

export default branch(
  {
    pos: BLOCKS.MAP.CURSOR_POSITION,
  },
  CoordsBlock,
);
